/**
     * Scroll to Cart section
     */
 $('.header_btn, .btn:not(.cta)').on('click', function (event) {
    $('html, body').animate({
        scrollTop: $("#orderNow").offset().top
    }, 1000);
});